const staging = {
  pubnubPublishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
  pubnubSubscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
  rootUrl: '.getvisitapp.xyz',
  apiBaseUrl: 'https://api.getvisitapp.net/stoker',
  notificationChannel: 'visit-network-requests',
  verificationUrl: 'https://payments.samuraijack.xyz',
  googleAuthConfig: {
    clientId:
      '1063005261362-lt3godueipbjm5c9kjdnd5nflq6800o5.apps.googleusercontent.com',
    scopes: ['email', 'profile', 'openid'],
  },
  networkBaseUrl: 'https://network.getvisitapp.net',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAm9jhep23-QqlHfxbsHiBp8Ux7O5vi_Q8',
  useNativeGoogleAuth: false,
  onDemandOauthBaseUrl: 'https://api.getvisitapp.com/v3',
};

export default staging;
